<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12" md="8" offset-md="2" xl="6" offset-xl="3" align="center">
        <v-card class="mb-2">
          <v-progress-linear v-model="value" :buffer-value="bufferValue"></v-progress-linear>
          <v-card-text class="pb-1">
            <p>You'll be redirected to the <router-link id="home-link" to="/">Home Page</router-link> in {{timeLeft}} seconds </p>
          </v-card-text>
        </v-card>
        <v-card class="px-5 pb-5">
          <v-card-title class="justify-center">
            <p class="farmer_green--text headline mb-0">Welcome to Zambezi Farmer</p>
          </v-card-title>
          <v-divider class="mb-5"></v-divider>
          <p>Soon you'll receive a confirmation e-mail, once you receive it please use the provided link to activate your account.</p>
          <p class="welcome pt-3">Thanks for choosing us!</p>
          <v-card-actions class="justify-center">
            <v-btn outlined color="primary" @click="goToPath('/')">Check out available products</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { goToPath } from '@/mixins'

export default {
  data() {
    return {
      value: 0,
      bufferValue: 100,
      timeLeft: 20
    }
  },
  methods: {
    startBuffer() {
      this.interval = setInterval(() => {
        this.value += this.bufferValue / 20
        this.timeLeft--
        if (this.timeLeft <= 0) {
          goToPath('/')
        }
      }, 1000)
    }
  },
  mounted() {
    this.startBuffer()
  },
  beforeDestroy() {
    clearInterval(this.interval)
  }
}
</script>

<style lang="css" scoped>
* {
  font-family: 'Muli', sans-serif;
}
.welcome {
  font-size: 20px;
}

#home-link {
  text-decoration: none;
}
</style>
